import layoutHeaderAside from '@/layout/header-aside'

const meta = { requiresAuthA: true }

export default {
  path: '/sys',
  name: 'sys',
  meta,
  redirect: { name: 'sys-managerPage' },
  component: layoutHeaderAside,
  children: (pre => [
    { path: 'permission/managerPage', name: `${pre}managerPage`, component: () => import('@/pages/sys/managerPage'), meta: { meta, title: '管理员管理' } },
    { path: 'permission/rolePage', name: `${pre}rolePage`, component: () => import('@/pages/sys/rolePage'), meta: { meta, title: '角色管理' } },
    { path: 'dataDictionary', name: `${pre}dataDictionary`, component: () => import('@/pages/sys/dataDictionary'), meta: { meta, title: '数据字典' } },
    { path: 'serviceCenter', name: `${pre}serviceCenter`, component: () => import('@/pages/sys/serviceCenter'), meta: { meta, title: '客服中心' } },
    { path: 'protocolPage/privacyProtocol', name: `${pre}privacyProtocol`, component: () => import('@/pages/sys/privacyProtocol'), meta: { meta, title: '隐私协议' } },
    { path: 'protocolPage/userProtocol', name: `${pre}userProtocol`, component: () => import('@/pages/sys/userProtocol'), meta: { meta, title: '用户协议' } },
    { path: 'protocolPage/aboutUs', name: `${pre}aboutUs`, component: () => import('@/pages/sys/aboutUs'), meta: { meta, title: '关于我们' } },
    { path: 'protocolPage/integralRule', name: `${pre}integralRule`, component: () => import('@/pages/sys/integralRule'), meta: { meta, title: '积分规则' } },
    { path: 'helpDoc', name: `${pre}helpDoc`, component: () => import('@/pages/sys/helpDoc'), meta: { meta, title: '帮助文档' } }
  ])('sys-')
}
